import { useNavigate } from 'react-router-dom'
import { useGetQuery } from 'hooks'
import { Card, IconLink, Table } from '../../../components'

export const Roles = () => {
  const navigate = useNavigate()
  const { data } = useGetQuery({ url: '/admin/roles' })

  return (
    <Card>
      <Table
        data={data?.roles?.rows || []}
        className="stretch"
        columns={[
          {
            title: 'Role',
            key: 'name'
          },
          {
            title: 'Actions',
            key: 'slug',
            className: 'right',
            render: (slug) => (
              <IconLink
                icon="pen"
                onClick={() => navigate(`/admin/roles/${slug}`)}
                width="18"
                height="18"
              />
            )
          }
        ]}
      />
    </Card>
  )
}
